export default __webpack_public_path__ + "static/media/instagram.6a4a6314.png";